import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import { ReactComponent as ErrorIcon } from '../../../../../assets/icons/svg/stamp-icons/ic-stamp-alert-triangle.svg';
import Heading from '../../../../../generic-components/Heading';
import { FORGOT_EMAIL_PAGE_DATA, GENERAL_STYLE } from '../constants';
import { UserMessage } from '../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { SIGN_UP_URL } from '../../../constants';
import { CloseButton, CloseButtonSize } from '../../../../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps{
    onMainActionClick: () => void
    onSecondaryActionClick: () => void
    onClose: () => void
}
export const ForgotEmailErrorModal = ({
  onMainActionClick, onSecondaryActionClick, onClose,
}: IProps) => {
  const { t } = useTranslation();
  console.log(onMainActionClick);
  return (
    <UserMessage onClick={onClose} id=''>
      <div className={`${GENERAL_STYLE.LOGIN_CARD.CLASS_NAME} flex flex-col items-center`}>
        <CloseButton onClick={onClose} id='closeButton' className='absolute right-0 my-[-30px] mx-[10px]' size={CloseButtonSize.Large} />
        <ErrorIcon className='mb-[20px]' />
        <Heading
          title='Sorry...'
          className={`${GENERAL_STYLE.HEADING.CLASS_NAME} mb-[16px] text-center`}
        />
        <p className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} mb-[24px] text-center`}>
          {t(FORGOT_EMAIL_PAGE_DATA.RECOVER_EMAIL_ERROR)}
          {' '}
          <a
            className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} text-action03 hover:text-action04`}
            href={SIGN_UP_URL}
          >
            {t(FORGOT_EMAIL_PAGE_DATA.SIGN_UP_BUTTON_TITLE)}
          </a>
        </p>
        <LiliButton
          className={`${GENERAL_STYLE.MAIN_BUTTON.CLASS_NAME} mb-[24px]`}
          id='tryAgainButton'
          title='Got It'
          onClick={onSecondaryActionClick}
        />
        {/* <Button */}
        {/*  className={GENERAL_STYLE.SECONDARY_BUTTON.CLASS_NAME} */}
        {/*  id='d' */}
        {/*  title='Later' */}
        {/*  onClick={onSecondaryActionClick} */}
        {/* /> */}
      </div>
    </UserMessage>
  );
};
